import React from 'react';
import { Container, Button, Modal, Popup, Form, Icon, Input, Checkbox } from 'semantic-ui-react'
import DataTable from 'react-data-table-component';
import { useSelector, useDispatch } from 'react-redux';
import {
   getShift,
   saveShift,
   updateShift,
   statusShift,
   deleteShift
} from '../Redux/Actions/ShiftAction'
import { Formik } from 'formik'
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import moment from "moment";
import TimePicker from 'react-time-picker';
import ConfirmModal from '../Components/ConfirmModal';
import TableLoader from '../Components/TableLoader';

const Shift = () => {

   const inputRef = React.useRef();
   const dispatch = useDispatch()
   React.useEffect(() => {
      dispatch(getShift(toast, authToken))
      inputRef.current && inputRef.current.focus();
   }, [])

   const authToken = localStorage.getItem('accessToken');
   const [openModal, setOpenModal] = React.useState(false)
   const [openConfirm, setOpenConfirm] = React.useState(false)
   const [actionMode, setActionMode] = React.useState('');
   const [rowData, setRowData] = React.useState([]);
   const [searchInput, setSearchInput] = React.useState('');
   const loadingData = useSelector(state => state.loadingReducer.loadingPayload);
   const isPageLoading = loadingData && loadingData.string === 'list' ? loadingData.status : false

   const shiftData = useSelector(state => state.shiftReducer.shiftPayload)
   const filteredItems = shiftData && shiftData.filter(item => (
      item.name.toLowerCase().includes(searchInput.toLowerCase())
   ));

   const searchComponent = <Input icon='search' placeholder='Search..' value={searchInput} onChange={e => setSearchInput(e.target.value)} />

   const actions = <React.Fragment>
      <Button
         primary
         onClick={() => (setOpenModal(true), setActionMode('Add'))}>
         <Icon name='add circle' />
         Add New
      </Button>
   </React.Fragment>;

   const conditionalRowStyles = [
      {
         when: row => row.status === 'I',
         style: {
            backgroundColor: '#f3f3f3',
            color: 'rgb(132 132 132 / 87%)'
         },
      }
   ]

   const columns = [
      {
         name: 'Shift Name',
         selector: 'name',
         sortable: true,
      },
      {
         name: 'Start Time',
         selector: 'start_time',
         sortable: true,
      },
      {
         name: 'End Time',
         selector: 'end_time',
         sortable: true,
      },
      {
         name: 'Action',
         sortable: false,
         allowOverflow: true,
         button: true,
         width: '56px',
         right: true,
         cell: (data) =>
            <Popup
               style={{ padding: 0 }}
               position='left center'
               trigger={<Button color='basic' icon="ellipsis vertical" />}
               on='click'>
               <Button.Group vertical labeled icon color='basic' style={{ border: 0 }}>
                  <Button
                     icon='edit'
                     content='Edit'
                     onClick={() => (
                        setRowData(data),
                        setOpenModal(true),
                        setActionMode('Edit'))} />
                  <Button
                     icon='trash alternate outline'
                     content='Delete'
                     onClick={() => (
                        setOpenConfirm(true),
                        setRowData(data),
                        setActionMode('Delete'))} />
                  {data.status === 'I' ?
                     <Button icon='lock open' content='Active'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('Active'))} /> :
                     <Button icon='lock' content='InActive'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('InActive'))} />}
               </Button.Group>
            </Popup>
      },
   ];

   const customStyles = {
      header: {
         style: {
            minHeight: '40px',
         },
      },
      headRow: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            height: '10px',
            minHeight: '40px'
         },
      },
      table: {
         minHeight: '400px'
      },
      headCells: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            color: '#FFF',
            fontSize: '16px',
            fontWeight: '700',
         },
      }
   }

   const userSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, 'Post name is too short!')
         .max(50, 'Post name is too Long!')
         .required('Post name is required'),
      start_time: Yup.string()
         .required('Start time is required'),
      end_time: Yup.string()
         .required('End time is required'),
   });


   return (
      <div>
         <Container fluid>
            <DataTable
               title='Shift Management'
               columns={columns}
               customStyles={customStyles}
               data={filteredItems}
               actions={actions}
               pagination={true}
               paginationResetDefaultPage={true}
               conditionalRowStyles={conditionalRowStyles}
               persistTableHead
               subHeader
               subHeaderComponent={searchComponent}
               progressPending={isPageLoading}
               progressComponent={<TableLoader />}
            />
            <Modal open={openModal} size='tiny'>
               <Formik
                  enableReinitialize
                  initialValues={{
                     id: actionMode === "Add" ? "" : rowData.id,
                     name: actionMode === "Add" ? "" : rowData.name,
                     start_time: actionMode === "Add" ? new Date("Wed Jun 16 2021 10:00:00 GMT+5:30") : new Date(`Wed Jun 16 2021 ${rowData.start_time} GMT+5:30`),
                     end_time: actionMode === "Add" ? new Date("Wed Jun 16 2021 18:00:00 GMT+5:30") : new Date(`Wed Jun 16 2021 ${rowData.end_time} GMT+5:30`),
                     isNight: actionMode === "Add" ? false : rowData.isNight
                  }}
                  validationSchema={userSchema}
                  onSubmit={(values, actions) => {
                        dispatch(saveShift(values, actions, setOpenModal, actionMode, toast, authToken))
                  }}>
                  {({
                     values,
                     errors,
                     touched,
                     handleChange,
                     handleBlur,
                     isSubmitting,
                     handleSubmit,
                     setFieldValue
                  }) => (
                     <React.Fragment>
                        <Modal.Header>{actionMode === "Edit" ? 'Update Shift' : 'Create Shift'}</Modal.Header>
                        <Modal.Content>
                           <Form id="myForm">
                              <Form.Group widths='equal'>
                                 <Form.Input
                                    error={errors.name && touched.name ? { content: errors.name } : false}
                                    fluid
                                    label='Post Name'
                                    placeholder='Post Name'
                                    type="text"
                                    value={values.name}
                                    onChange={handleChange('name')}
                                 />
                              </Form.Group>
                              <Form.Group widths='equal'>
                                 <Form.Field>
                                    <label>Start Time</label>
                                    <DatePicker
                                       selected={values.start_time}
                                       value={values.start_time}
                                       onChange={date => (setFieldValue("start_time", date))}
                                       showTimeSelect
                                       showTimeSelectOnly
                                       timeIntervals={15}
                                       timeCaption="Start Time"
                                       dateFormat="h:mm aa"
                                    />
                                 </Form.Field>
                                 <Form.Field>
                                    <label>Start Time</label>
                                    <DatePicker
                                       selected={values.end_time}
                                       value={values.end_time}
                                       onChange={(date) => setFieldValue("end_time", date)}
                                       showTimeSelect
                                       showTimeSelectOnly
                                       timeIntervals={15}
                                       timeCaption="End Time"
                                       dateFormat="h:mm aa"
                                    />
                                 </Form.Field>
                                 <Form.Input
                                    error={errors.total_time && touched.total_time ? { content: errors.total_time } : false}
                                    fluid
                                    label='Total Hour'
                                    readOnly
                                    placeholder='HH:MM'
                                    type="text"
                                    value={moment(values.end_time).diff(moment(values.start_time), 'hours')}
                                    onChange={handleChange('total_time')}
                                 />
                                 <Form.Field style={{ float: 'right' }}>
                                    <label>Night Shift</label>
                                    <Checkbox
                                       checked={values.isNight}
                                       onChange={(e, { checked }) => setFieldValue("isNight", checked)}
                                       toggle />
                                 </Form.Field>
                              </Form.Group>
                           </Form>
                        </Modal.Content>
                        <Modal.Actions>
                           <Button negative type="cancel" onClick={() => (dispatch(getShift(toast, authToken)), setOpenModal(false))}>
                              Close
                           </Button>
                           <Button
                              content={actionMode === "Edit" ? "Save" : "Create"}
                              type="submit"
                              labelPosition='right'
                              icon='checkmark'
                              loading={isSubmitting}
                              onClick={handleSubmit}
                              positive
                              form="myForm"
                              key="submit"
                              htmlType="submit"
                           />
                        </Modal.Actions>
                     </React.Fragment>
                  )}
               </Formik>
            </Modal>
            <Formik
               enableReinitialize
               initialValues={{
                  id: rowData.id,
                  status: actionMode === 'InActive' ? "I" : actionMode === 'Active' ? "A" : "D"
               }}
               onSubmit={(values, actions) => {
                  actionMode === 'Delete' ?
                     dispatch(deleteShift(values, actions, setOpenConfirm, toast, authToken)) :
                     dispatch(statusShift(values, actions, setOpenConfirm, toast, authToken))
               }}>
               {({
                  isSubmitting,
                  handleSubmit
               }) => (
                  <ConfirmModal
                     icon="trash alternate outline"
                     color="red"
                     open={openConfirm}
                     cancelText="Cancel"
                     comfirmText="Delete"
                     header={
                        actionMode === 'Delete' ? 'Delete Record' :
                           actionMode === 'InActive' ? 'Inactive Record' :
                              actionMode === 'Active' ? 'Active Rocord' : null
                     }
                     content={
                        actionMode === 'Delete' ? 'Data rocord will lost' :
                           actionMode === 'InActive' ? 'Data record will inactive.' :
                              actionMode === 'Active' ? 'Data record will active?' : null
                     }
                     onCancel={() => setOpenConfirm(false)}
                     onConfirm={handleSubmit}
                     loading={isSubmitting} />
               )}
            </Formik>
         </Container>
      </div>
   )
}

export default Shift